<template>
    <dropdown-popover v-model="isOpen" position="bottom">
        <span
            class="font-mono text-xs text-theme-base cursor-pointer"
            :class="{ 'break-all': full }"
        >
            {{ displayValue }}
        </span>

        <template #tooltip>
            <div class="flex flex-col gap-2 p-3 min-w-55">
                <p class="font-mono text-xs break-all text-theme-base">
                    {{ value }}
                </p>
                <app-button size="small" border @click="copy">
                    <span class="flex items-center gap-1">
                        <copy-icon class="w-3.5 h-3.5" />
                        {{ copyLabel }}
                    </span>
                </app-button>
            </div>
        </template>
    </dropdown-popover>
</template>

<script>
import CopyIcon from "@/components/icons/CopyIcon.vue";

export default {
    name: "UuidDisplay",
    components: { CopyIcon },
    props: {
        value: { type: String, required: true },
        full: { type: Boolean, default: false }
    },
    data: () => ({
        isOpen: false,
        copied: false
    }),
    computed: {
        truncatedValue() {
            return `${this.value.slice(0, 8)}...${this.value.slice(-4)}`;
        },
        displayValue() {
            return this.full ? this.value : this.truncatedValue;
        },
        copyLabel() {
            return this.copied ? "Copiado" : "Copiar";
        }
    },
    methods: {
        async copy() {
            await navigator.clipboard.writeText(this.value);
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 1500);
        }
    }
};
</script>
